import React from 'react';
import './StatsBar.css';

export default function StatsBar({ stateName, stats, lang }) {
  const L = (en, hi) => lang === 'en' ? en : hi;
  if (!stats || stats.total === 0) return null;
  return (
    <div className="stats-bar">
      <span className="stats-state">{stateName}</span>
      <div className="stats-pills">
        <span className="pill pill-total">{stats.total} {L('sites','स्थल')}</span>
        {stats.hindu    > 0 && <span className="pill pill-hindu">⬤ {stats.hindu} {L('Hindu','हिंदू')}</span>}
        {stats.buddhist > 0 && <span className="pill pill-buddhist">⬤ {stats.buddhist} {L('Buddhist','बौद्ध')}</span>}
        {stats.jain     > 0 && <span className="pill pill-jain">⬤ {stats.jain} {L('Jain','जैन')}</span>}
        {stats.alzhwar  > 0 && <span className="pill pill-alzhwar"><span style={{color:'#c0392b'}}>☸</span> {stats.alzhwar} {L('Āḻvārs','अल्झवार')}</span>}
        {stats.nayanmars > 0 && <span className="pill pill-nayanmars">🔱 {stats.nayanmars} {L('Nayanmars','नयनमार')}</span>}
      </div>
    </div>
  );
}
